<template>
  <div class="container-view-container">
      <div class = "container-status">
        <img
          :src="require('@/assets/icons/icon-container.svg')"
          alt="Container icon"
          style="height: 60%;"
        />
        <div class="container-status-text"> {{ container_status }} </div>
      </div>
      <ContainerTabs></ContainerTabs>
      <!--<div class="container-view-content">-->
        <ContainerActions v-if="container_view_selected_tab=='actions'"></ContainerActions>
        <ContainerDocs v-if="container_view_selected_tab=='docs'"></ContainerDocs>
        <ContainerTracking v-if="container_view_selected_tab=='tracking'"></ContainerTracking>
        <ContainerDetails v-if="container_view_selected_tab=='details'"></ContainerDetails>
      <!--</div>-->
  </div>
</template>

<script>
import { getData } from '@/services/api'
import { mapGetters } from 'vuex'
import { actionApiToFront, getExpedientStatus, statusName, updateContainerActions } from '@/services/helper'
import ContainerTabs from '@/components/containerViews/ContainerTabs'
import ContainerActions from '@/components/containerViews/ContainerActions'
import ContainerDocs from '@/components/containerViews/ContainerDocs'
import ContainerTracking from '@/components/containerViews/ContainerTracking'
import ContainerDetails from '@/components/containerViews/ContainerDetails'

export default {
  name: 'ContainerView',
  components: {
      ContainerTabs,
      ContainerActions,
      ContainerDocs,
      ContainerTracking,
      ContainerDetails
  },
  computed: {
    ...mapGetters(["view_role"]),  
    ...mapGetters("user",{
      isLoggedIn: 'isLoggedIn',
      user: 'user'
    }),
    ...mapGetters("container",{
      container_id: 'container_id',
      container_status: 'container_status',
    }),
    ...mapGetters(["container_view_selected_tab"]),  
  },
  mounted () {
    updateContainerActions(this.container_id)
    this.$store.dispatch('change_container_view_selected_tab', {tab: 'actions'});
    //this.getContainerActions()
    this.getDocuments()
    //this.$store.commit('set_view_name', [this.container_id])
  },
  methods: {
    /*getContainerActions: function(){
      getData('expedientes/' + this.container_id + '/actions/').then(res => {
        // SET STATE OF EACH ACTION IN VUEX
        this.setActionsState(res.data)
        
        // SET GLOBAL CONTAINER STATE IN VUEX
        var status = getExpedientStatus(res.data)
        var statusFixedName = statusName(status.state)
        this.$store.commit('container/set_container_status', statusFixedName)
      });
    },
    setActionsState: function (actions) {
      actions.forEach(action => {
        var actionsToDispatch = []
        var actionToDispatch = actionApiToFront(action)      
        actionsToDispatch.push(actionToDispatch)
        console.log(actionsToDispatch)
        this.$store.dispatch('container/actionsUpdate',actionsToDispatch)
        .then(resp => { console.log(resp) })
        .catch(err => {console.log(err) })
      });              
    },*/
    getDocuments: function () {
      getData('events/?expediente=' + this.container_id).then(res => {
        var events = res.data
        var docs = []
        events.forEach(event => {
          if(event.document) {
            docs.push(event.document)
          }
        })
        this.$store.commit('container/set_availableDocuments',docs)
      })
    }
  }
}
</script>

<style lang= "scss" scoped>

.container-view-container {
    width: 100%;
    height: 100%;
}
.container-status {
    height: 40px;
    width: 100%;
    padding: 0 20px;
    background-color: $nav-background-mobile;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    border-bottom: 2px solid #2B816E;
}
.container-status-text {
  flex: 1;
  margin-left: 15px;
}
.container-view-content {
  background-color:lightpink;
  flex: 1;
  min-height: 0;
  max-height: 80%;
  overflow: scroll;
}
</style>
